import { ContactEntity } from '@/entities/interfaces/contacts';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const useContactStore = defineStore('contact', () => {
  const contact = ref<ContactEntity>();

  const getContact = computed(() => contact);

  const setContact = (action: ContactEntity) => {
    contact.value = action;
  };

  return { contact, setContact, getContact };
});
